import React from 'react';
import { Section } from '../ui/Section';
import { Check, X } from 'lucide-react';
export function IsThisForYou() {
  const isForYou = ['Querés variedad sin pensar menús cada día', 'Cocinás para tu familia y buscás opciones para todos', 'Seguís una dieta específica (keto, sin gluten, vegano)', 'Te gusta cocinar por tandas y tener el freezer lleno', 'Buscás recetas probadas que congelen bien'];
  const isNotForYou = ['Buscás comida preparada lista para comer', 'Esperás que incluya ingredientes o delivery', 'Querés coaching nutricional personalizado', 'No tenés freezer o no te interesa congelar'];
  return <Section className="bg-white" data-id="element-130">
      <div className="text-center mb-6 md:mb-8" data-id="element-131">
        <h2 className="text-2xl md:text-3xl font-bold text-brand-slate-900 mb-4" data-id="element-132">
          ¿Es para vos?
        </h2>
        <p className="text-brand-slate-600 max-w-xl mx-auto" data-id="element-133">
          Queremos que compres con confianza. Este pack es ideal si buscás
          resolver tus comidas con organización.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-134">
        {/* Es para vos */}
        <div className="bg-brand-ice/50 p-6 rounded-2xl border border-brand-sky/20" data-id="element-135">
          <h3 className="text-xl font-bold text-brand-slate-900 mb-6 flex items-center gap-2" data-id="element-136">
            <span className="w-8 h-8 rounded-full bg-brand-sky text-white flex items-center justify-center text-sm" data-id="element-137">
              <Check className="w-5 h-5" data-id="element-138" />
            </span>
            Es para vos si...
          </h3>
          <ul className="space-y-4" data-id="element-139">
            {isForYou.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-140">
                <Check className="w-5 h-5 text-brand-sky flex-shrink-0 mt-0.5" data-id="element-141" />
                <span className="text-brand-slate-700 text-sm md:text-base" data-id="element-142">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>

        {/* No es para vos */}
        <div className="bg-brand-slate-50 p-6 rounded-2xl border border-brand-slate-200" data-id="element-143">
          <h3 className="text-xl font-bold text-brand-slate-900 mb-6 flex items-center gap-2" data-id="element-144">
            <span className="w-8 h-8 rounded-full bg-brand-slate-200 text-brand-slate-500 flex items-center justify-center text-sm" data-id="element-145">
              <X className="w-5 h-5" data-id="element-146" />
            </span>
            No es para vos si...
          </h3>
          <ul className="space-y-4" data-id="element-147">
            {isNotForYou.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-148">
                <X className="w-5 h-5 text-brand-slate-400 flex-shrink-0 mt-0.5" data-id="element-149" />
                <span className="text-brand-slate-600 text-sm md:text-base" data-id="element-150">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </Section>;
}